import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConvocatoriaService } from 'app/services/convocatoria.service';

@Component({
  selector: 'app-nueva',
  templateUrl: './nueva.component.html',
  styleUrls: ['./nueva.component.scss']
})
export class NuevaComponent implements OnInit {
  tipo: string;
  convocatoria: string;
  loading: boolean;
  convocatorias: any;
  convocatoriaForm: FormGroup;
  loadingsubmit: boolean;


  constructor(private route: ActivatedRoute,private convocatoriaService: ConvocatoriaService, private fb: FormBuilder) {

    this.route.params.subscribe(routeParams => {

      this.tipo=routeParams.tipo;

      this.convocatoriaForm = this.fb.group({
        TIPO: new FormControl(this.tipo),
        CONVOCATORIAS: this.fb.array([
          this.fb.group({
        IDCONVOCATORIA: new FormControl(''),
        CODIGO: new FormControl(''),
        CONVOCATORIA: new FormControl(''),
        ESTADO: new FormControl('')
          })
        ])

      });
    

      
      if(this.tipo == "2") { this.convocatoria='Seguimiento'};
      if(this.tipo == "1") { this.convocatoria='Implanta'};
      this.loadAllConvocatorias();
    });



   // this.tipo = String(this.route.snapshot.params['tipo']);

   }

  ngOnInit() {
  }
  

  setConvocatorias() {
    const convocatoriaFGs = this.convocatorias.map(convocatoria => this.fb.group(convocatoria)) ;
    const convocatoriaFormArray = this.fb.array(convocatoriaFGs);
    this.convocatoriaForm.setControl('CONVOCATORIAS', convocatoriaFormArray);
    this.loading = false;
  }

  addConvocatoria() {
    const conv = this.convocatoriaForm.get('CONVOCATORIAS') as FormArray;
    conv.push( this.fb.group({
      IDCONVOCATORIA: new FormControl('0'),
      CODIGO: new FormControl(''),
      CONVOCATORIA: new FormControl(''),
      ESTADO: new FormControl('00')
        }));
  }

  private loadAllConvocatorias() {

    this.loading = true;
    this.convocatoriaService.getAll(this.tipo,0).subscribe(
      data => {
        this.convocatorias = data.convocatorias;
        console.log(data);
        this.setConvocatorias();
       
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }



  onSubmit() {
    this.loadingsubmit=true;
    this.convocatoriaService.putAll(this.tipo,this.convocatoriaForm.value ).subscribe(
      data => {  this.loadingsubmit = false; this.loadAllConvocatorias();},
      error => {if (error.status == 401 || error.status == 413) { this.loadingsubmit = false;  }}
    );
  }
  


}



// WEBPACK FOOTER //
// /app/src/app/modules/convocatorias/nueva/nueva.component.ts